// extracted by mini-css-extract-plugin
module.exports = {"Team":"Team_Team__2zzhF","Title":"Team_Title__F8FOz","Dots":"Team_Dots__2AtJJ","List":"Team_List__2dhGe","Student":"Team_Student__3608W","Tooltip":"Team_Tooltip__2nBf7"};